<script setup lang="ts">
import type { Schemas } from '#shopware'

interface ProductSizesProps {
    product: Schemas['Product']
    itemsContainerClass?: string
    itemClass?: string
}

 
const props = withDefaults(defineProps<ProductSizesProps>(), {
    itemsContainerClass: 'justify-center',
    itemClass: 'me-1 mb-1',
})

const sizes = computed<string[]>(() => {
    const raw = (props.product.customFields as Record<string, unknown>)?.['gisy_available_sizes']
    return Array.isArray(raw) ? (raw as string[]).filter((s) => s !== '-') : []
})
</script>

<template>
    <div class="flex flex-wrap" :class="itemsContainerClass">
        <div
            v-for="size in sizes"
            :key="size"
            class="border border-border w-11 text-sm text-center"
            :class="itemClass"
        >
            {{ size }}
        </div>
    </div>
</template>